import { inject } from "@angular/core";
import { AutoSaveService, EventSectionEditService } from "./route.service";
import { CanDeactivateFn } from "@angular/router";
import Swal from 'sweetalert2';
import { NotificationService } from '@fry-it/risr-core';

async function confirm() {
    const confirmation = await Swal.fire({
        title: 'Do you want to discard your changes?',
        text: 'Are you sure you want to leave this page?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, leave it!',
        cancelButtonText: 'No, stay here'
    });
    return confirmation.isConfirmed;
}

export const autosaveGuard: CanDeactivateFn<any> = async () => {
    const autoSaveService: any = inject(AutoSaveService);
    const eventSectionEditService: any = inject(EventSectionEditService);
    const info = eventSectionEditService.autoSaveInfo;
    const notify = inject(NotificationService)
    if (!info) {
        return true;
    }
    if (info.ignoreExit) {
        return true;
    }
    if (info.isNew) {
        if (info.state === 'none' || info.state === undefined) {
            return true;
        }
        const leave = await confirm();
        if (leave) {
            try {
                await autoSaveService.removeObject(info);
            } catch (e) {
                notify.error('Failed to clean up the autosave');
                return false;
            }
            return true;
        }
        return false;
    }
    if (info.id) {
        const leave = await confirm();
        if (leave) {
            try {
                await autoSaveService.removeAutoSave(info, info.id);
            } catch (e) {
                notify.error('Failed to clean up the autosave');
                return false;
            }
            return true;
        }
        return false;
    }
    if (info.shouldSave) {
        const leave = await confirm();
        return leave;
    }
    return true;
}